module.exports = __webpack_public_path__ + "img/like-fill.04964d3e.svg";